// extracted by mini-css-extract-plugin
export default {"paddingTop":"landers_paddingTop__Q8EmY"};